export default __webpack_public_path__ + "static/media/ID_1.2701e818.png";